import styled from 'styled-components'
import { breakpoints } from '../../../../constants'
import {
	BLUE,
	SILVER,
	STRONGORANGE,
	PRIMARY_COLOR,
	MEDIUMGRAY,
} from '../../../../styles/colors.style'

export const ContainerHistoric = styled.section`
	display: flex;
	flex-direction: column;
	padding: 10px 6px 0;

	@media (min-width: ${breakpoints.MOBILE}px) {
		width: 70%;
	}
`

export const Title = styled.h3`
	color: ${BLUE};
	font: 600 18px/25px 'Source Sans Pro';
	text-transform: uppercase;
	border-bottom: 1px solid ${SILVER};
	padding: 0 0 10px;
	margin: 0;
	&.-desktop {
		display: none;
	}

	@media (min-width: ${breakpoints.MOBILE}px) {
		&.-mobile {
			display: none;
		}
		&.-desktop {
			font-size: 25px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			color: ${STRONGORANGE};
			border-bottom: 1px solid ${STRONGORANGE};
			padding-bottom: 5px;
		}

		em {
			color: ${MEDIUMGRAY};
			font: 13px/16px 'Source Sans Pro';
			text-transform: none;
		}
	}
`

export const Footer = styled.footer`
	min-height: 5vh;
	display: flex;
	justify-content: center;
	align-items: center;

	@media (min-width: ${breakpoints.MOBILE}px) {
		display: none;
	}

	.lk-footer {
		font: 600 15px/19px 'Source Sans Pro';
		color: ${STRONGORANGE};
		text-decoration: underline;

		@media (min-width: ${breakpoints.MOBILE}px) {
		}
	}
`
